import { RootState } from '@algoan/dashboard/store/store';
import { activityLoadingSelector } from './activity-selectors';
import { AsyncStatus } from '@algoan/dashboard/model';
import { createSelector } from '@reduxjs/toolkit';

export const activityPageLoadingSelector: (state: RootState) => boolean = createSelector(
  (state: RootState): AsyncStatus => state.activityPage.refreshInProgress,
  activityLoadingSelector,
  (refreshInProgressStatus, activityLoadingStatus): boolean =>
    activityLoadingStatus || refreshInProgressStatus === AsyncStatus.PENDING,
);
